export default "__VITE_PUBLIC_ASSET__0023d962__"